import type { RootState } from 'state';
import FetchingStatus from 'constants/statuses/FetchingStatus';

function isFetchingInProgress(state: RootState): boolean {
  const { fetching } = state.dataService.staticData.languages;

  return fetching === FetchingStatus.InProgress;
}

export default isFetchingInProgress;
